import { I18n } from '@affine/i18n';
import { registerEmbedDocCardTranslator } from '@blocksuite/affine-shared/services';

const EMBED_DOC_CARD_I18N_PREFIX = 'com.streamlain.embedDocCard.';

registerEmbedDocCardTranslator({
  translate: key => {
    const fullKey = `${EMBED_DOC_CARD_I18N_PREFIX}${key}`;
    const translated = I18n.t(fullKey);
    return translated === fullKey ? undefined : translated;
  },
  locale: () => I18n.language,
});
